import React, { useState, useEffect } from 'react';
import API from '../api'; // Configura l'oggetto Axios
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ProductSkeleton } from './skeleton';

// Frecce custom SVG
const NextArrow = (props) => (
  <button {...props} className="store-slider-arrow next" aria-label="Avanti">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 4l8 8-8 8" stroke="#c93249" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  </button>
);
const PrevArrow = (props) => (
  <button {...props} className="store-slider-arrow prev" aria-label="Indietro">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16 4l-8 8 8 8" stroke="#c93249" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  </button>
);

const StoreSlider = ({ sliderTitle = 'Scopri i negozi' }) => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        setLoading(true);
        const res = await API.get('/seller');
        setStores(res.data.sellers || []);
      } catch (error) {
        console.error('Errore durante il recupero dei negozi:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStores();
  }, []);

  // Configurazione dello slider
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    <div className="store-slider-container">
      <div className="store-slider-title-row">
        <h2 className="store-slider-title">
          {sliderTitle}
          <Link to="/seller" className="store-slider-link">Vedi tutti</Link>
        </h2>
      </div>
      {loading ? (
        <ProductSkeleton view="slider" count={6} />
      ) : stores.length > 0 ? (
        <div className="store-slider-wrapper">
          <Slider {...sliderSettings}>
            {stores.map((store) => (
              <div key={store.id} className="store-card-custom">
                <Link to={`/seller/${store.seller_handle}`} className="store-card-link">
                  <div className="store-card-inner-custom">
                    <div className="store-logo-container-custom">
                      <img
                        src={store.store_logo_square || '/placeholder-store.jpg'}
                        alt={store.store_name}
                        className="store-logo-custom"
                      />
                    </div>
                    <div className="store-info-custom">
                      <span className="store-name-custom">{store.store_name}</span>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <div className="store-slider-empty">
          <p className="store-slider-empty-text">Nessun negozio trovato.</p>
        </div>
      )}
    </div>
  );
};

export default StoreSlider;